// Lazy load видео hero
import heroDesktopWebm from '../img/hero/hero_desktop_optimized.webm';
import heroDesktopMp4 from '../img/hero/hero_desktop_optimized.mp4';
import heroMobileWebm from '../img/hero/hero_mobile_optimized.webm';
import heroMobileMp4 from '../img/hero/hero_mobile_optimized.mp4';
import heroDesktopImg from '../img/hero/hero.webp';
import heroMobileImg from '../img/hero/hero-mobile.webp';

export function initHeroLazyLoad() {
  document.addEventListener('DOMContentLoaded', function () {
    let video = document.querySelector('.hero__video');
    let posterImg = document.querySelector('.hero__poster-fallback img');
    if (!video || !posterImg) return;
    let isDesktop = window.innerWidth >= 768;
    let webm = isDesktop ? heroDesktopWebm : heroMobileWebm;
    let mp4 = isDesktop ? heroDesktopMp4 : heroMobileMp4;
    let poster = isDesktop ? heroDesktopImg : heroMobileImg;
    video.innerHTML = '<source src="' + webm + '" type="video/webm" /><source src="' + mp4 + '" type="video/mp4" />';
    video.setAttribute('poster', poster);
    video.style.display = 'block';
    posterImg.src = poster;
    posterImg.style.display = 'none';
    video.load();

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            video.play();
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(video);
  });
}
